// Single source of truth for client-side config across all stages. Stage-varying
// values come from `import.meta.env.VITE_*` (populated per stage from the
// packages/web/.env.<stage> files at build time) — there is no build-time file
// replacement, so do NOT reintroduce a parallel `environment.prod.ts`.

export const environment = {
  production: false,
  // Publishable key for the stage's Stripe account. MUST match the mode
  // (test/live) of the backend's STRIPE_API_KEY, or Stripe.js can't resolve a
  // PaymentIntent's client_secret ("does not match any associated PaymentIntent
  // on this account"). Falls back to the shared test key for local dev.
  stripeKey:
    import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ??
    'pk_test_51Kb5omCZAQl1OOa7Opo0wjJT5fUIMzcWTJ5HkK7lRLAazD20rTLsnFaVU4Bq2cFYHIlVZTMuvy3mqGT63TqDgDmW00Yzji4MD0',
  stripePricingTable: 'prctbl_1NtFYiCZAQl1OOa7rusK7jHQ',
  tinyApiKey: 'nyrh6gewaeow55etx0pi88ti0rg4iwsye77wdmq9b0wuv180',
  // Loaded from VITE_GOOGLE_MAPS_API_KEY in packages/web/.env.local
  // The key should be HTTP-referrer-restricted in Google Cloud Console
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '',
  // Inbound-email address domain (docs.<env>.partners.farmshare.co); empty when
  // inbound email isn't enabled for this stage.
  inboundEmailDomain: import.meta.env.VITE_INBOUND_EMAIL_DOMAIN ?? '',
  // Deployment stage: 'production', 'staging', 'dev', … — empty when running
  // locally. This, not `import.meta.env.PROD` or `process.env.NODE_ENV`, is
  // how to ask "is this the production stage?": every deployed stage is a
  // production BUILD, so those two are true on dev and staging as well.
  env: import.meta.env.VITE_ENV ?? '',
  // Contentsquare tag ID. Only populated on production — see lib/contentsquare.ts.
  contentsquareTagId: import.meta.env.VITE_CONTENTSQUARE_TAG_ID ?? '',
};
